import { getRioClient } from '@chegg-me-components/utils';
/* istanbul ignore next */

var rioEndpoint = process.env.NODE_ENV === 'development' ? 'http://localhost:8042/' : 'https://analytics.test.cheggnet.com/rio-service-web/rest/rio-events/batch';
export var rioConfig = {
  property: 'chegg',
  endpoint: rioEndpoint,
  authState: 'hard_logged_in',
  appId: 'signed-in-footer',
  view: {
    property: 'chegg',
    experience: 'bundle',
    view_name: 'signed-in-footer'
  }
};
export var rioClient = getRioClient();